export class ModificacionDatos {
    _id_modificacion: Number;
    rut: String;
    nombre: String;
    telefono: String;
    email: String;
    numero_cliente: String;
    direccion: String;
    id_comuna: String;
    id_region: String;
    soy_propietario: Boolean;
    soy_arrendatario: Boolean;
    razon_social: String;
    giro: String;
    rut_comercial: String;
    requiere_emision_factura: Boolean;
    requiere_emision_boleta: Boolean;
    archivo_rut_representante: String;
    archivo_rut_representante_reverso: String;
    archivo_rut_empresa: String;
    archivo_titulo_dominio: String;
    archivo_poder_simple: String;
    acepto_condiciones: Boolean;
    acepto_newsletters: Boolean;
    acepto_privacidad: Boolean;
    acepto_suscripcion: Boolean;
    token: String;
    ip: String;
 }